module.exports = __webpack_public_path__ + "static/media/create_page_couple.4c48acd0.jpg";